var _rect, _rect2, _g, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgSoonBlueBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 713,
    height: 400,
    viewBox: "0 0 713 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.998,
    height: 26.8293,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 291.67 86.4912)",
    fill: "#E3F2FD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24.2748,
    height: 24.1231,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 294.046 87.48)",
    fill: "#90CAF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.188 172.48L412.163 165.538V181.571L412.187 181.558C412.311 182.582 413.051 183.587 414.408 184.37L529.315 250.707C532.301 252.431 537.144 252.431 540.131 250.707L646.476 189.313C648.071 188.392 648.814 187.165 648.705 185.959V170.284L636.519 177.32L531.569 116.732C528.582 115.008 523.74 115.008 520.753 116.732L424.188 172.48Z",
    fill: "url(#paint0_linear)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 135.283,
    height: 145.169,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 409 165.638)",
    fill: "#90CAF9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 135.283,
    height: 145.169,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 409 165.638)",
    fill: "url(#paint1_linear)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 128.598,
    height: 137.995,
    rx: 5,
    transform: "matrix(0.866041 -0.499972 0.866041 0.499972 415.002 165.761)",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 348.163,
    y: 115.439,
    width: 364.552,
    height: 284.561,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 84
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.129412 0 0 0 0 0.588235 0 0 0 0 0.952941 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 530.44,
    y1: 158.777,
    x2: 412.163,
    y2: 183.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1DCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 1.14127,
    y1: 6.08432,
    x2: 46.0633,
    y2: 95.9332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91CBFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -42.0844,
    y1: -101.822,
    x2: 33.5428,
    y2: 92.0592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91CBFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSoonBlueBlock);
export default __webpack_public_path__ + "static/media/img-soon-blue-block.5621676f9e90c33b10e131c1bf4495f6.svg";
export { ForwardRef as ReactComponent };